module.exports = __webpack_public_path__ + "static/media/royal-suite-img6.1c0151ec.jpg";